<template>
  <!-- Review Section 07 -->
  <div class="review">
    <section class>
      <div class="container">
        <div class="container">
          <div class="">
            <div class="hero-textn">
              <h2>{{ $root.review.text_review }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-image">
        <img class src="/assets/exported/review.jpg" alt />
      </div>
    </section>
    <section>
      <div class="container course_hero review_hero">
        <div class="container list_hide">
          <li
            v-for="(rev, rev_i) in review"
            v-bind:key="rev.id"
            class="quiz_box"
          >
            <span class="dot_position">
              <dot />
            </span>
            <h3>{{ rev.title }}</h3>
            <div
              v-for="ans in rev.answers"
              :key="ans.id"
              class="review_ans radio-item"
            >
              <label>
                <input
                  v-model="reviewQuestion[rev_i]"
                  type="radio"
                  :name="'question_group_' + rev.id"
                  :id="'question_group_' + rev.id"
                  :value="ans.id"
                />
                {{ ans.name }}
              </label>
            </div>
          </li>
          <ul class="content-list">
            <li class="content-list_slide">
              <a @click="ReviewOnSubmit()" class="quiz_sub">
                <i class="icon icon-check-2"></i>
                {{ $root.review_submit.text_review_submit }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import Dot from "../../assets/js/dot";
import swal from "sweetalert";
export default {
  data: () => {
    return {
      reviewQuestion: [],
      review: [],
      answers: [],
      reviews: {
        Answer: "",
      },
    };
  },
  components: {
    dot: Dot,
  },
  mounted() {
    this.reloadAPI();
    this.$root.page_hook = this;
  },
  methods: {
    reloadAPI() {
      // Get Data From Offline
      if (!navigator.onLine) {
        this.isLoading = false;
        if (window.localStorage.getItem("review-question") != null) {
          console.log("Local Data: review-question");
          var localData = JSON.parse(
            window.localStorage.getItem("review-question")
          );
          this.review = localData;
          // Reset Answers
          for (var i = 0; i < this.review.length; i++) {
            this.reviewQuestion[i] = 0;
          }
          return;
        }
      }

      var user_profile = JSON.parse(window.localStorage.getItem("profile"));
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
          Authorization: "bearer " + user_profile.token,
        },
      };
      axios
        .get(this.$root.API_BASE_URL + "review-question", config)
        .then((response) => {
          // Response received From Server
          // this.isLoading = false;
          console.log(response.data);
          if (response.data == []) {
            // Blank
            return;
          }

          //
          this.review = response.data.data;

          // Save Locally
          localStorage.setItem(
            "review-question",
            JSON.stringify(response.data.data)
          );

          // Reset Answers
          for (var i = 0; i < this.review.length; i++) {
            this.reviewQuestion[i] = 0;
          }

          console.log(this.review);
        });
    },
    ReviewOnSubmit() {
      //question condition
      for (var i = 0; i < this.review.length; i++) {
        if (this.reviewQuestion[i] == 0) {
          //alert("Please Answer All Questions!");
          swal({
            text: "দয়া করে, সমস্ত প্রশ্নের উত্তর দিন!",
            buttons: {
              confirm: { text: "ঠিক আছে" },
            },
          });
          return;
        }
      }
      //offline Status
      if (navigator.onLine) {
        console.log(this.reviewQuestion);
        var user_profile = JSON.parse(window.localStorage.getItem("profile"));
        var config = {
          headers: {
            "X-localization": this.$root.translate ? "bn" : "en",
            Authorization: "bearer " + user_profile.token,
          },
        };
        var reviewBody = { review_question_answer_id: this.reviewQuestion };

        axios
          .post(
            this.$root.API_BASE_URL + "user-review-submit",
            reviewBody,
            config
          )
          .then((response) => {
            // Response received From Server
            console.log(response.data);
            if (response.data == []) {
              // Blank
              return;
            }
            this.sendans = response.data.data;
            console.log(this.sendans);

            // Show Certificate
            this.$root.checkReview(() => {
              this.$router.push("/certificate");
            });
          });
      } else {
        var reviewData = {
          review_question_answer_id: this.reviewQuestion,
          sync: false,
        };
        localStorage.setItem("_review", JSON.stringify(reviewData));

        swal({
          text: "সার্টিফিকেটটি পেতে আপনার ইন্টারনেট কানেকশনটি একটিভেট করুন",
          buttons: {
            confirm: { text: "ঠিক আছে" },
          },
        });

        this.$router.push("/");

        //this.connectionStatus = "Unable to connect to internet.";
      }
    },
  },
};
</script>
<style scoped></style>
